import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { LANGUAGES } from '@store';

import { NO_VALUE } from '../dash/dash.pipe';

@Pipe({
  name: 'language',
  standalone: true,
})
export class LanguagePipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}

  transform(locale = ''): string {
    locale = locale.toLowerCase();
    locale = locale.replace('_', '-');
    const languageCode = locale.split('-')[0];
    const language = LANGUAGES.find((lang) => lang.code === languageCode);
    if (language) {
      return this.translateService.instant(language.name);
    } else if (locale) {
      return locale;
    } else {
      return NO_VALUE;
    }
  }
}
